import Slider from '../components/Slider';
import Aos from '../components/aos';
import ReactDOM from "react-dom";
import PersonnelIndex from "../components/PersonnelIndex"; // eslint-disable-line
import ProgramIndex from '../components/ProgramIndex'; // eslint-disable-line
import VideoPlayer from "../components/VideoPlayer";
import InstagramGallerySlider from '../components/instagramGallerySlider';

/**
 * Front Page
 */
const PageFrontPage =( $ )=>{

	if ( $( 'body' ).hasClass( 'home' ) ) {
		Slider( $ );
		Aos();
		VideoPlayer($);
		InstagramGallerySlider($);
		const themeArtistsGrid = document.getElementById("js-theme-artists");


		if(themeArtistsGrid.dataset.limit > 0) {
			ReactDOM.render(
				<PersonnelIndex {...themeArtistsGrid.dataset} />,
				themeArtistsGrid
			);
		}

		const themeProgramsGrid = document.getElementById("js-theme-programs");

		ReactDOM.render(
			<ProgramIndex {...themeProgramsGrid.dataset} />,
			themeProgramsGrid
		);
	}

};

export default PageFrontPage;
